enum IAnalysisStatus {
  'IN_PROGRESS' = 'IN_PROGRESS',
  'COMPLETED' = 'COMPLETED',
  'TIMED_OUT' = 'TIMED_OUT',
  'CREATED' = 'CREATED',
  'FAILED' = 'FAILED',
}

export default IAnalysisStatus;
